export default "/images/411b41106ebd15edbb0b5bb88ebd17bb.avif";